import { ZodType } from 'zod';

export const load = <T>(key: string, validationSchema?: ZodType): T | null => {
  if (typeof window === 'undefined') return null;
  const item = window.localStorage.getItem(key);
  if (!item) {
    return null;
  }
  try {
    const parsedItem = JSON.parse(item) as T;
    if (validationSchema) {
      const validatedItem = validationSchema.safeParse(parsedItem);
      if (!validatedItem.success) {
        console.warn(
          `Local storage item with key: ${key} failed validation on load.`,
          validatedItem.error.issues,
        );
        return null;
      }
    }
    return parsedItem;
  } catch (err) {
    console.warn(`Error retrieving key: ${key} from local storage`, err);
    return null;
  }
};

export const save = <T>(key: string, value: T, validationSchema?: ZodType): T => {
  if (!window?.localStorage) return value;
  if (validationSchema) {
    const validatedItem = validationSchema.safeParse(value);
    if (!validatedItem.success) {
      console.warn(
        `Intended local storage item with key: ${key} failed validation, aborting save.`,
        validatedItem.error.issues,
      );
      return value;
    }
  }
  localStorage.setItem(key, JSON.stringify(value));
  return value;
};

export const remove = (key: string) => {
  if (!window?.localStorage) return;
  window.localStorage.removeItem(key);
};
